import { createContext, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "../../../redux/actions/loadingActions/loadingActions";
import {
  changePasswordAuthService,
  editInfoUserService,
  sendEmailOTPUserService,
  sendPhoneNumberOTPUserService,
  verifyEmailOTPUserService,
  verifyPhoneNumberOTPUserService,
} from "../../../services/userServices";
import {
  deliverySuccessMessage,
  toastErrorMessage,
  toastSuccessMessage,
} from "../../../utils/toastMessage/toastMessage";
import { secondsCountDown } from "../../../utils";
import { setUserAction } from "../../../redux/actions/userActions/userActions";

export const profileUserContext = createContext({
  otpType: "",
  setOtpType: () => {},
  handleEditUserInfo: () => {},
  handleChangePassword: () => {},
  handleSendPhoneNumberOTP: () => {},
  handleVerifyPhoneNumberOTP: () => {},
  handleSendEmailOTP: () => {},
  handleVerifyEmailOTP: () => {},
});

const ProfileUserContext = ({ children }) => {
  const dispatch = useDispatch();

  const user = useSelector((state) => state.user);

  const [otpType, setOtpType] = useState("");

  // Edit User Info
  const handleEditUserInfo = async (userData) => {
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await editInfoUserService(userData);
      if (status === 200) {
        toastSuccessMessage(data.resultMessage);
        dispatch(setUserAction());
      }
    } catch ({ response }) {
      
      if (response && response.status)
        toastErrorMessage(response.data.resultMessage);
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Change Password
  const handleChangePassword = async (userData) => {
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await changePasswordAuthService(userData);
      if (status === 200) {
        deliverySuccessMessage(data.resultMessage, "/auth/logout", "3000");
      }
    } catch ({ response }) {
      
      if (response && response.status)
        toastErrorMessage(response.data.resultMessage);
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Send Phone Number OTP
  const handleSendPhoneNumberOTP = async () => {
    const objData = {
      phoneNumber: user.phoneNumber,
    };
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await sendPhoneNumberOTPUserService(objData);
      if (status === 200) {
        toastSuccessMessage(data.resultMessage);
        setOtpType("phoneNumber");
        secondsCountDown("otpCountdown", 300, () => setOtpType(""));
      }
    } catch ({ response }) {
      
      if (response && response.status)
        toastErrorMessage(response.data.resultMessage);
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Verify Phone Number OTP
  const handleVerifyPhoneNumberOTP = async (userData) => {
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await verifyPhoneNumberOTPUserService(userData);
      if (status === 200) {
        toastSuccessMessage(data.resultMessage);
        setOtpType("");
        dispatch(setUserAction());
      }
    } catch ({ response }) {
      
      if (response && response.status)
        toastErrorMessage(response.data.resultMessage);
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Send Email OTP
  const handleSendEmailOTP = async () => {
    const objData = {
      email: user.email,
    };
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await sendEmailOTPUserService(objData);
      if (status === 200) {
        toastSuccessMessage(data.resultMessage);
        setOtpType("email");
        secondsCountDown("otpCountdown", 300, () => setOtpType(""));
      }
    } catch ({ response }) {
      
      if (response && response.status)
        toastErrorMessage(response.data.resultMessage);
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Verify Email OTP
  const handleVerifyEmailOTP = async (userData) => {
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await verifyEmailOTPUserService(userData);
      if (status === 200) {
        toastSuccessMessage(data.resultMessage);
        setOtpType("");
        dispatch(setUserAction());
      }
    } catch ({ response }) {
      
      if (response && response.status)
        toastErrorMessage(response.data.resultMessage);
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  return (
    <>
      <profileUserContext.Provider
        value={{
          otpType,
          setOtpType,
          handleEditUserInfo,
          handleChangePassword,
          handleSendPhoneNumberOTP,
          handleVerifyPhoneNumberOTP,
          handleSendEmailOTP,
          handleVerifyEmailOTP,
        }}
      >
        {children}
      </profileUserContext.Provider>
    </>
  );
};

export default ProfileUserContext;
